import { SelectedOptions } from '@shopify/hydrogen-react/ProductProvider';
import { ProductOption, SelectedOption, Media } from '@shopify/hydrogen-react/storefront-api-types';
import classNames from 'classnames';
import React from 'react';
import Tooltip from '../../../components/ui/Tooltip';
import { optionCombinationExists, handleOptionSelect } from '../functions';

interface Props {
  onSelectedOptions: (options: SelectedOptions) => void;
  selectedOptions: SelectedOptions;
  availableOptions: SelectedOption[][];
  optionGroup: ProductOption;
}

const OptionColor: React.FC<Props> = ({
  onSelectedOptions,
  selectedOptions,
  optionGroup,
  availableOptions,
}) => {
  // Helper function to safely get image URL from Media interface
  const getImageUrl = (media: Media | null | undefined): string | undefined => {
    if (!media) return undefined;

    // For all Media types, use the previewImage if available
    if (media.previewImage?.url) {
      return media.previewImage.url;
    }

    return undefined;
  };

  return (
    <div className="product-options-group color">
      {optionGroup.optionValues.map((optionValue, key) => {
        const selectedOption =
          optionGroup?.name && selectedOptions && selectedOptions[optionGroup.name];

        // Use the swatch color if available
        const colorValue = optionValue.swatch?.color || '';

        // Get image URL from Media object
        const imageUrl = getImageUrl(optionValue.swatch?.image as Media);
        const hasImageSwatch = !!imageUrl;

        if (!optionGroup?.name) {
          return null;
        }

        const isAvailable = optionCombinationExists(
          availableOptions,
          selectedOptions,
          optionGroup.name,
          optionValue.name
        );

        return (
          <div key={key}>
            <div
              className={classNames({
                'product-options-group-item': true,
                'color-item': true,
                active: selectedOption === optionValue.name,
                disabled: !isAvailable,
              })}
              key={key}
              style={{
                backgroundColor: hasImageSwatch ? 'transparent' : colorValue,
                borderColor: colorValue,
                backgroundImage: hasImageSwatch ? `url(${imageUrl})` : 'none',
                backgroundSize: hasImageSwatch ? 'cover' : 'auto',
              }}
              onClick={() =>
                selectedOption !== optionValue.name &&
                isAvailable &&
                onSelectedOptions(
                  handleOptionSelect(selectedOptions, optionGroup.name, optionValue.name)
                )
              }
            ></div>
            <Tooltip text={optionValue.name} />
          </div>
        );
      })}
    </div>
  );
};

export default OptionColor;
